<button class="button" [ngClass]="buttonClasses" [disabled]="disabled" (click)="onClick($event)">
  <ng-content></ng-content>
</button>